







import LoaderReport from "@/components/utility/LoaderReport.vue";
import eventBus from "@/lib/eventBus";
import { LocalHostToPartnerMapper } from "@/lib/utility/local-host-to-partner-mapper";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { BankingModule } from "@/store/modules/banking.store";
import { ConfigModule } from "@/store/modules/config";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user.store";
import { MissingInformationHandler } from "@/lib/notification/MissingUserInformationHandler";

@Component({
  components: { LoaderReport }
})
export default class V extends Vue {
  created() {
    ConfigModule.setThgBaseUrl();
    ConfigModule.setisBankingAvailable(true);
    ConfigModule.setThgSupportMail();
    this.trySetStepperByPath();

    ConfigModule.setNavigationSettings({
      showMmmmintLogo: false,
      showThePartnerList: false,
      showTheAdminList: false,
      showTheThgList: true,
      showTheAboutList: false,
      showThgAboutList: true,
      showThgFeatureSettings: true
    });

    ConfigModule.setPartnerSelectorDestinationVue("ThgDashboardPartnerSelected");
  }

  async mounted() {
    eventBus.$on("login", () => {
      try {
        BankingModule.getMyBanking();
      } catch (error) {
        this.$log.error(error);
      }
    });

    eventBus.$on("logout", () => {
      this.$log.info("Handle Logout Event");
      this.$router.push({ name: "Logout" });
    });

    eventBus.$on("sessionExpired", () => {
      //handle forced logout
      this.$router.push({ path: "/login/logout?reason=expired" });
    });

    eventBus.$on("userUpdated", async () => {
      await MissingInformationHandler.check();
    });

    eventBus.$on("bankingUpdated", async () => {
      await MissingInformationHandler.check();
    });

    try {
      if (this.$route.query.code) {
        ThgCreateModule.setCode((this.$route.query.code as string) || "");
        this.$log.info("code set in THG.Vue");
      }

      if (this.$route.query.campaign) {
        ThgCreateModule.setCampaign((this.$route.query.campaign as string) || "");
        this.$log.info("campaign set in THG.Vue");
      }
    } catch (error) {
      this.$log.error("Faild to load code and campaign from query");
    }

    try {
      await LocalHostToPartnerMapper.tryGetPartnerByHost(window.location.hostname, {
        localhost: "devappwirkaufendeinethg"
      });
    } catch (error) {
      this.$log.error(error);
      this.$toast("Fehler beim Laden der Anwendung.");
      this.$router.push({ name: "PartnerContactError" });
    } finally {
      ReportModule.setLoading(false);
    }

    if (UserModule.isAuthenticated) {
      MissingInformationHandler.check();
    }
  }

  get loading() {
    return ReportModule.loading;
  }

  trySetStepperByPath() {
    const route = this.$route.path;
    const parts = route.split("/"); // "/3" -> ["", "3" ]
    const maybeAStep: string = parts[1];
    if (Object.values(ReportScreenEnum).includes(maybeAStep as ReportScreenEnum)) {
      ReportModule.setStep(maybeAStep as ReportScreenEnum);
    }
  }
}
